module.exports = __webpack_public_path__ + "static/media/049.d49ef5b5.png";